import api from "./api";

export interface TransferItem {
  product_id: number;
  qty: number;
  product_name?: string;
  product_code?: string;
  product?: {
    name?: string;
    code?: string;
  };
  unit_cost?: number;
  cost?: number;
  tax?: number;
  unit_tax?: number;
  product_variant_id?: number;
}

export interface TransferWarehouse {
  id?: number;
  code?: string;
  name?: string;
}

export interface Transfer {
  id?: number;
  from_warehouse_id: number | null;
  to_warehouse_id: number | null;
  from_wh_code?: string;
  from_wh_name?: string;
  to_wh_code?: string;
  to_wh_name?: string;
  from_warehouse?: TransferWarehouse;
  to_warehouse?: TransferWarehouse;
  ref: string;
  items: TransferItem[];
  total_tax?: number;
  grand_total?: number;
  total?: number;
  note?: string;
  shipping?: number;
  status?: string;
  created_by?: number;
  created_at?: string;
  updated_at?: string;
}

class TransferService {
  private normalizeList(value: unknown): Transfer[] {
    if (Array.isArray(value)) {
      return value as Transfer[];
    }

    if (value && typeof value === "object") {
      const maybeData = (value as { data?: unknown }).data;
      if (Array.isArray(maybeData)) {
        return maybeData as Transfer[];
      }
    }

    return [];
  }

  async getAll(params?: { search?: string; from_warehouse_id?: number; to_warehouse_id?: number }): Promise<Transfer[]> {
    const response = await api.get("/stock-movements", { params });
    return this.normalizeList(response.data);
  }

  async get(id: number): Promise<Transfer> {
    const response = await api.get(`/stock-movements/${id}`);
    return response.data?.data ?? response.data;
  }

  async create(data: Transfer): Promise<Transfer> {
    const response = await api.post("/stock-movements", data);
    return response.data?.data ?? response.data;
  }

  async update(id: number, data: Transfer): Promise<Transfer> {
    const response = await api.put(`/stock-movements/${id}`, data);
    return response.data?.data ?? response.data;
  }

  async delete(id: number) {
    return api.delete(`/stock-movements/${id}`);
  }

  async getNextReference(): Promise<string> {
    const response = await api.get("/stock-movements/next-reference");
    return response.data?.data ?? response.data ?? "";
  }
}

export default new TransferService();
